var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content"},[_c('Breadcrumb',{staticClass:"bread"},[_c('BreadcrumbItem',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t('聯絡我們')))])],1),_c('Card',[_c('div',{staticClass:"contact-info",domProps:{"innerHTML":_vm._s(_vm.contactInfo)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }